(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ChatInvoiceNewController', ChatInvoiceNewController);

    function ChatInvoiceNewController(currentCustomer, cartProducts, $q, UserService, StoreInfoFactory,
                                      $localStorage, toastr, $translate, $uibModalInstance, $filter, $location, $rootScope,
                                      $scope, InvoicesService, CheckCEPService, StoreService, FlyersService, $window,
                                      systemConstants, InvoiceUtilsService) {

        var vm = this;

        vm.isImmoContext = false;
        vm.fixedValue = null;
        vm.standaloneProductName = null;
        vm.salesPoints = [];
        vm.selectedSalesPointId = null;
        vm.formatSalesPointAddress = InvoiceUtilsService.formatSalesPointAddress;
        vm.paymentLinkMessage = '';
        vm.isSaving = false;
        vm.isGeneratingLink = false;
        vm.paymentLinkEnabled = InvoiceUtilsService.isPaymentLinkEnabled();
        vm.paymentConditionOptions = InvoiceUtilsService.getPaymentConditionOptions('communication.modal-new-order');
        vm.externalChannelOptions = InvoiceUtilsService.getExternalChannelOptions(false);

        function refreshImmoContext() {
            var fromHub = vm.hubId != null && vm.hubId === systemConstants.IMMO_HUB_ID;
            var fromStorage = !!($localStorage.defaultStore && $localStorage.defaultStore.immoContext);
            vm.isImmoContext = fromHub || fromStorage;
        }

        refreshImmoContext();

        vm.randomTime = new Date().getTime();
        vm.currentCustomer = currentCustomer;
        vm.isBrl = true;

        vm.height = window.innerHeight;
        vm.states = getAllStates();

        function setDynamicDivHeight() {
            vm.height = window.innerHeight;
        }

        window.addEventListener('load', setDynamicDivHeight);
        window.addEventListener('resize', setDynamicDivHeight);

        StoreService.getStore($localStorage.defaultStore.storeId).then(function (response) {
            vm.store = response.data;
            vm.storeCategory = response.data.categoryKey;
            vm.hubId = vm.store.hubId;
            refreshImmoContext();
        });

        // Auxiliaries for sellers entities
        vm.querySearchSellers = querySearchSellers;
        vm.selectedSellerChange = selectedSellerChange;

        vm.invoice = {
            storeId: StoreInfoFactory.getStoreId(),
            externalChannel: 'SHOWKASE',
            shippingOption: 'PICK_UP_IN_STORE',
            paymentMethod: 'DIRECT_SALE',
            paymentCondition: 'MONEY',
            availablePaymentConditions: [],
            shippingValue: 0,
            customer: vm.currentCustomer ? vm.currentCustomer : {},
            items: []
        }

        vm.selectedCoupon = undefined;
        vm.purchaseValue = 0;
        vm.currencyPrefix = getCurrencyListConfiguration()['REAL']

        init();

        function init() {
            loadStore();
            getUsersSellers();
            loadCartProducts();
            loadSalesPoints();
            $translate.onReady(function () {
                regeneratePaymentLinkMessageIfPristine();
            });
        }

        function buildPaymentLinkMessage() {
            return InvoiceUtilsService.buildPaymentLinkMessage(vm.invoice.customer, 'communication.modal-new-order');
        }

        function regeneratePaymentLinkMessageIfPristine() {
            var ctrl = $scope.chatInvoiceNewForm && $scope.chatInvoiceNewForm.paymentLinkMessage;
            if (!ctrl || ctrl.$pristine) {
                vm.paymentLinkMessage = buildPaymentLinkMessage();
            }
        }

        vm.isPaymentConditionSelected = function (value) {
            return InvoiceUtilsService.isPaymentConditionSelected(vm.invoice.availablePaymentConditions, value);
        };

        vm.togglePaymentCondition = function (value) {
            InvoiceUtilsService.togglePaymentCondition(vm.invoice.availablePaymentConditions, value);
        };

        vm.onFixedValueInput = function () {
            var hasItems = vm.invoice.items && vm.invoice.items.length;
            var action = InvoiceUtilsService.resolveFixedValueInputAction(hasItems, vm.fixedValue);

            if (action === 'RESET_WITH_WARNING') {
                toastr.warning($translate.instant('communication.modal-new-order.messages.fixed-value-not-allowed-with-products'));
            }

            if (action === 'RESET_WITH_WARNING' || action === 'RESET') {
                $scope.$applyAsync(function () {
                    vm.fixedValue = null;
                    vm.calculatePrice();
                });
                return;
            }

            vm.calculatePrice();
        };

        function loadCurrencyPrefix(store) {
            vm.invoice.currency = store.currency ? store.currency : 'REAL';
            var config = getCurrencyListConfiguration()[vm.invoice.currency];
            vm.currencyPrefix = config.prefix;
        }

        function loadStore() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function (response) {
                if (response && response.data) {
                    vm.store = response.data;
                    vm.storeCategory = response.data.categoryKey;
                    vm.hubId = response.data.hubId;
                    vm.isBrl = response.data.langKey == 'pt-br';
                    loadCurrencyPrefix(vm.store)
                    refreshImmoContext();
                }
            });
        }

        function loadCartProducts() {
            if (!cartProducts || cartProducts.length == 0) {
                return;
            }

            var flyerIds = cartProducts.map(function (product) {
                return getProductIdFromCart(product);
            });

            FlyersService.findFlyersByIds(flyerIds).then(function (response) {
                if (response && response.data && response.data.length > 0) {
                    cartProducts.forEach(function (product) {
                        var flyerId = product.productRetailerId;
                        if (flyerId.includes('_')) {
                            var parts = flyerId.split('_');
                            var id = parts[0];
                            var size = parts[1];
                            var flyer = getFlyerById(response.data, id);
                            var detail = getDetailBySize(flyer, size);
                            if (flyer) {
                                selectedProductFromFlyer(flyer, detail, product.quantity);
                            }
                        } else {
                            var flyer = getFlyerById(response.data, flyerId);
                            if (flyer) {
                                selectedProductFromFlyer(flyer, null, product.quantity);
                            }
                        }
                    });
                    if (vm.invoice.items.length != cartProducts.length) {
                        toastr.warning($translate.instant('communication.modal-new-order.messages.some-products-not-found'));
                    }
                } else {
                    toastr.warning($translate.instant('communication.modal-new-order.messages.products-not-found'));
                }
            });
        }

        function getProductIdFromCart(product) {
            var id = product.productRetailerId;
            if (id.includes('_')) {
                var parts = id.split('_');
                return parts[0];
            }

            return id;
        }

        function getFlyerById(flyers, flyerId) {
            if (!flyers || flyers.length == 0 || !flyerId) {
                return null;
            }

            var selecteds = flyers.filter(function (flyer) {
                return flyer.id === flyerId;
            });

            return selecteds && selecteds.length > 0 ? selecteds[0] : null;
        }

        function getDetailBySize(flyer, size) {
            if (!flyer || !size || !flyer.details || flyer.details.length == 0) {
                return null;
            }

            var selecteds = flyer.details.filter(function (detail) {
                return detail.size === size;
            });

            return selecteds && selecteds.length > 0 ? selecteds[0] : null;
        }

        function loadSalesPoints() {
            if (!vm.paymentLinkEnabled) {
                return;
            }
            StoreService.getSalesPoints($localStorage.defaultStore.storeId).then(function (response) {
                vm.salesPoints = (response && response.data) ? response.data : [];
                vm.selectedSalesPointId = InvoiceUtilsService.autoSelectSalesPoint(vm.salesPoints, vm.selectedSalesPointId);
            });
        }

        function getUsersSellers() {
            UserService.getUsersSellers({storeId: vm.invoice.storeId}).then(function (response) {
                vm.sellers = response.data;
                vm.searchTextSeller = ''
                var defaultSeller = _.find(vm.sellers, function (user) {
                    return user.id === $localStorage.userId;
                });
                selectedSellerChange(defaultSeller || null);
            });
        }

        function querySearchSellers(query) {
            var results = query ? vm.sellers.filter(InvoiceUtilsService.buildSellerFilter(query)) : vm.sellers;
            var defer = $q.defer();
            defer.resolve(results);
            return defer.promise;
        }

        function selectedSellerChange(seller) {
            if (seller) {
                vm.invoice.sellerId = seller.id;
                vm.invoice.sellerName = seller.fullName;
                vm.selectedSeller = seller;
            } else {
                vm.invoice.sellerId = null;
                vm.invoice.sellerName = null;
                vm.selectedSeller = null;
            }
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.getTreatedName = function (item) {
            return InvoiceUtilsService.getTreatedName(item);
        }

        vm.selectedProduct = function (item) {
            if (InvoiceUtilsService.hasPositiveFixedValue(vm.fixedValue)) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.fixed-value-blocks-product'));
                return;
            }
            selectedProductFromFlyer(item.originalObject, null, 1);
        }

        vm.selectedDiscountCoupon = function (item) {
            if (item && item.originalObject && item.originalObject.code) {
                if (!isDiscountCouponValid(item.originalObject)) {
                    toastr.warning($translate.instant('communication.modal-new-order.messages.invalid-discount-coupon'));
                    return;
                }
                vm.invoice.discountCoupon = item.originalObject.code;
                vm.selectedCoupon = item.originalObject;
            } else {
                vm.invoice.discountCoupon = undefined;
                vm.selectedCoupon = undefined;
            }
            vm.calculatePrice();
        }

        function isDiscountCouponValid(item) {
            return item && (!item.hasUsageLimit || !item.couponAvailable || item.couponsAvailable > 0);
        }

        vm.deleteProduct = function (index) {
            vm.invoice.items.splice(index, 1);
            vm.calculatePrice();
        }

        vm.duplicateProduct = function (product) {
            if (!product.details || product.details.length === 0) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.product-cant-be-duplicated'));
                return;
            }

            vm.invoice.items.push({
                flyer: product,
                quantity: 1,
                detail: null
            });
        }

        vm.requestParams = function (query) {
            return {
                page: 0,
                size: 10,
                storeId: StoreInfoFactory.getStoreId(),
                search: query
            }
        }

        vm.requestDiscountCouponParams = function (query) {
            return {
                page: 0,
                size: 10,
                name: query,
                code: query,
                enabled: true
            }
        }

        vm.selectedCustomer = function (item) {
            if (item) {
                vm.invoice.customer = item.originalObject;
            }
            regeneratePaymentLinkMessageIfPristine();
        }

        vm.filterSizes = function (details) {
            if (!details) return [];
            if (vm.isImmoContext) {
                // Para contexto imobiliário, retorna todos os detalhes que têm unit
                return details.filter(function (detail) {
                    return detail.unit != null;
                });
            }
            return details.filter(function (detail) {
                return detail.inventory == null || detail.inventory > 0;
            })
        }

        vm.getAvailableColors = function (size, details) {
            if (!size || !details) return [];

            // Filtra os detalhes pelo tamanho selecionado
            var detailsWithSize = details.filter(function (detail) {
                return detail.size === size;
            });

            // Extrai as cores únicas dos detalhes filtrados
            var colors = [];
            detailsWithSize.forEach(function (detail) {
                if (detail.color && !colors.some(function (c) { return c.id === detail.color.id; })) {
                    colors.push(detail.color);
                }
            });

            return colors;
        };

        vm.updateDetailWithColor = function (item) {
            var colorId = parseInt(item.color);

            // Encontra o detail com o mesmo tamanho e cor
            var newDetail = item.flyer.details.find(function (detail) {
                return detail.size === item.detail.size &&
                    detail.color &&
                    detail.color.id === colorId;
            });

            if (newDetail) {
                item.detail = angular.copy(newDetail);
                vm.calculatePrice();
            }

        };

        vm.changeCustomer = function (value) {
            if (vm.invoice.customer && vm.invoice.customer.id) {
                vm.invoice.customer = {
                    fullName: value
                };
            } else if (!vm.invoice.customer.id) {
                vm.invoice.customer.fullName = value;
            }
            regeneratePaymentLinkMessageIfPristine();
        }

        vm.updatePurchaseValue = function () {
            vm.purchaseValue = vm.invoice.subTotal + vm.invoice.shippingValue - (vm.invoice.discount ? vm.invoice.discount : 0);
            if (!vm.invoice.subTotal || vm.invoice.subTotal < 0 || !vm.purchaseValue || vm.purchaseValue < 0) {
                vm.purchaseValue = 0;
            }
        }

        vm.getItemSubtotal = function (item) {
            var subTotal = 0;
            if (item.flyer.details && item.flyer.details.length) {
                if (item.detail) {
                    var value = item.detail.discountedValue ? item.detail.discountedValue : item.detail.purchaseValue;
                    subTotal += item.quantity * value;
                }
            } else {
                subTotal += item.quantity * (item.flyer.discountedValue ? item.flyer.discountedValue : item.flyer.purchaseValue);
            }

            return subTotal;
        }

        vm.getItemPrice = function (item) {
            if (item.flyer.details && item.flyer.details.length) {
                if (item.detail) {
                    return item.detail.discountedValue ? item.detail.discountedValue : item.detail.purchaseValue;
                }
            } else {
                return item.flyer.discountedValue ? item.flyer.discountedValue : item.flyer.purchaseValue;
            }

            return 0;
        }

        vm.calculatePrice = function () {
            var hasItems = !!(vm.invoice.items && vm.invoice.items.length);

            if (hasItems || vm.fixedValue) {
                InvoicesService.calculateDiscount(vm.invoice)
                    .then(function (response) {
                        if (response.data) {
                            vm.invoice.discount = response.data;
                        } else {
                            vm.invoice.discount = undefined;
                        }
                        vm.updatePurchaseValue();
                    }, function (err) {
                        vm.invoice.discount = undefined;
                        vm.updatePurchaseValue();
                    });
            } else {
                vm.invoice.discount = undefined;
            }

            var subTotal = 0;
            if (hasItems) {
                angular.forEach(vm.invoice.items, function (item) {
                    if (item.flyer.details && item.flyer.details.length) {
                        if (item.detail) {
                            subTotal += item.quantity * (item.detail.discountedValue ? item.detail.discountedValue : item.detail.purchaseValue);
                        }
                    } else {
                        subTotal += item.quantity * (item.flyer.discountedValue ? item.flyer.discountedValue : item.flyer.purchaseValue);
                    }
                })
            } else if (vm.fixedValue) {
                subTotal = vm.fixedValue;
            }

            vm.invoice.subTotal = subTotal;
            if (!vm.invoice.shippingValue) {
                vm.invoice.shippingValue = 0;
            }
            vm.invoice.total = subTotal;
            vm.updatePurchaseValue();
        }

        vm.changeQuantity = function (item, value) {
            verifyQuantityMessage(item, item.quantity + value);
            if (item.quantity + value <= 0) {
                return;
            }

            if (item.flyer.inventory && (item.quantity + value) <= item.flyer.inventory) {
                item.quantity += value;
            }

            if (item.detail && item.detail.inventory) {
                if ((item.quantity + value) <= item.detail.inventory) {
                    item.quantity += value;
                }
            } else if (item.detail && item.detail.inventory == null) {
                item.quantity += value;
            }

            if (item.detail == null && item.flyer.inventory == null && (item.flyer.details && item.flyer.details.length == 0)) {
                item.quantity += value;
            }

            vm.calculatePrice();
        }

        vm.getProductCount = function (item) {
            if (!vm.invoice.items) {
                return 0;
            }

            var count = 0;

            angular.forEach(vm.invoice.items, function (item) {
                if (item.flyer.details && item.flyer.details.length) {
                    if (item.detail) {
                        count += item.quantity;
                    }
                } else {
                    count += item.quantity;
                }
            })

            return count;
        }

        vm.onChangeQuantity = function (item) {
            verifyQuantityMessage(item, item.quantity);
            if (item.quantity < 0) {
                item.quantity = 0;
            } else if (item.detail && (item.quantity === undefined || item.quantity > item.detail.inventory)) {
                item.quantity = item.detail.inventory;
            } else if (!item.detail && item.flyer.inventory && item.flyer.inventory !== 0
                && (item.quantity === undefined || item.quantity > item.flyer.inventory)) {
                item.quantity = item.flyer.inventory;
            }

            vm.calculatePrice();
        }

        vm.save = function () {
            var saveErrorKey = InvoiceUtilsService.validateInvoiceForSave(vm.isImmoContext, vm.paymentLinkEnabled, vm.invoice, vm.fixedValue);
            if (saveErrorKey) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.' + saveErrorKey));
                return;
            }

            if (hasInvalidItem() || checkInvalidCustomer()) {
                return;
            }

            var request = InvoiceUtilsService.buildInvoiceRequest(vm.invoice, vm.isImmoContext, vm.selectedSalesPointId);
            if (!vm.isImmoContext) {
                request.paymentCondition = vm.paymentLinkEnabled
                    ? vm.invoice.availablePaymentConditions[0]
                    : vm.invoice.paymentCondition;
            }
            delete request.availablePaymentConditions;

            vm.isSaving = true;
            InvoicesService.createInvoice(request)
                .then(function (response) {
                    vm.isSaving = false;
                    if (response && response.data) {
                        vm.transactionId = response.data.id;
                    }
                    toastr.success($translate.instant('communication.modal-new-order.messages.invoice-created'));
                    // context immo
                    if (vm.isImmoContext) {
                        $uibModalInstance.close({message: transactionImmoToWhatsAppMessage()});
                    } else {
                        $uibModalInstance.close({message: transactionToWhatsAppMessage()});
                    }
                })
                .catch(function (err) {
                    vm.isSaving = false;
                    toastr.error($translate.instant('communication.modal-new-order.messages.error-to-created'));
                });
        }

        vm.finalizeWithLink = function () {
            if (vm.isImmoContext) {
                return;
            }

            var linkErrorKey = InvoiceUtilsService.validatePaymentLinkInvoice(vm.invoice, {
                fixedValue: vm.fixedValue,
                isImmoContext: vm.isImmoContext,
                salesPoints: vm.salesPoints,
                selectedSalesPointId: vm.selectedSalesPointId
            });
            if (linkErrorKey) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.' + linkErrorKey));
                return;
            }

            submitPaymentLinkInvoice();
        }

        function submitPaymentLinkInvoice() {
            var request = InvoiceUtilsService.buildPaymentLinkRequest(vm.invoice, {
                isImmoContext: vm.isImmoContext,
                fixedValue: vm.fixedValue,
                standaloneProductName: vm.standaloneProductName,
                selectedSalesPointId: vm.selectedSalesPointId,
                paymentLinkMessage: vm.paymentLinkMessage
            });

            vm.isGeneratingLink = true;
            InvoicesService.createPaymentLinkInvoice(request)
                .then(function (response) {
                    vm.isGeneratingLink = false;
                    var uuid = response && response.data ? response.data.uuid : null;
                    toastr.success($translate.instant('communication.modal-new-order.messages.payment-link-created'));
                    var url = uuid ? InvoiceUtilsService.buildPaymentLinkUrl(uuid) : '';
                    var message = (vm.paymentLinkMessage || '') + (url ? '\n\n' + url : '');
                    $uibModalInstance.close({message: message});
                })
                .catch(function (error) {
                    vm.isGeneratingLink = false;
                    toastr.error($translate.instant('communication.modal-new-order.messages.' + InvoiceUtilsService.resolvePaymentLinkCreateErrorKey(error)));
                });
        }

        vm.checkCEP = function () {
            if (vm.invoice.shippingOption === 'RECEIVE_AT_HOME' && vm.invoice.customer.zipcode && vm.invoice.customer.zipcode.length === 8) {
                CheckCEPService.getAddress(vm.invoice.customer.zipcode).then(function (response) {
                    if (response.data) {
                        vm.invoice.customer.address = response.data.name;
                        vm.invoice.customer.district = response.data.district.name;
                        vm.invoice.customer.city = response.data.location.name;
                        vm.invoice.customer.state = response.data.location.uf;
                    }
                });
            } else {
                vm.invoice.customer.state = null;
            }
        }

        vm.checkIfVariationAlreadyExists = function (item, index) {
            for (var i = 0; i < vm.invoice.items.length; i++) {
                var object = vm.invoice.items[i];
                if (item.flyer.id === object.flyer.id) {
                    if (vm.isImmoContext) {
                        // Para contexto imobiliário, compara por unit
                        if (item.detail && item.detail.unit === object.detail.unit && i !== index) {
                            toastr.warning($translate.instant('communication.modal-new-order.messages.immo-unit-already-exists'));
                            item.detail = undefined;
                            item.color = undefined;
                            return;
                        }
                    } else {
                        // Para outros contextos
                        if (item.detal && item.detail.size === object.detail.size &&
                            item.detail.color && object.detail.color &&
                            item.detail.color.id === object.detail.color.id &&
                            i !== index) {
                            toastr.warning($translate.instant('communication.modal-new-order.messages.product-variation-already-exists'));
                            item.detail = undefined;
                            item.color = undefined;
                            return;
                        }
                    }
                }
            }
        };

        function selectedProductFromFlyer(flyer, detail, quantity) {
            if (!flyer.details) {
                for (var i = 0; i < vm.invoice.items.length; i++) {
                    var object = vm.invoice.items[i];
                    if (flyer.id === object.flyer.id) {
                        toastr.warning($translate.instant('communication.modal-new-order.messages.product-already-exists'));
                        return;
                    }
                }
            } else if (!flyer.details && flyer.inventory === 0) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.product-without-inventory'));
                return;
            }

            vm.invoice.items.push({
                flyer: flyer,
                quantity: quantity,
                detail: detail
            });
            vm.calculatePrice();
        }

        function verifyQuantityMessage(item, value) {
            if (item.flyer.details && item.flyer.details.length > 0 && !item.detail) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.select-variation'));
            } else if (item.detail && item.detail.inventory && item.detail.inventory !== 0 && (value === undefined || value > item.detail.inventory)) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.limit-amount-reached'));
            } else if (!item.detail && item.flyer.inventory && item.flyer.inventory !== 0
                && (value === undefined || value > item.flyer.inventory)) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.limit-amount-reached'));
            }
        }

        function hasInvalidItem() {
            if (!vm.invoice.items || !vm.invoice.items.length) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.select-a-product'));
                return true;
            }

            var itemErrorKey = InvoiceUtilsService.validateInvoiceItems(vm.invoice.items, vm.isImmoContext);
            if (itemErrorKey) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.' + itemErrorKey));
                return true;
            }

            return false;
        }

        function hasInvalidCustomerBaseData() {
            var errorKey = InvoiceUtilsService.validateCustomerBaseData(vm.invoice.customer, vm.store && vm.store.hasErp);
            if (errorKey) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.' + errorKey));
                return true;
            }
            return false;
        }

        function hasInvalidShippingAddress() {
            var invalidAddress = InvoiceUtilsService.hasInvalidShippingAddress(vm.invoice);
            if (invalidAddress) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.invalid-customer-address'));
            }
            return invalidAddress;
        }

        function checkInvalidCustomer() {
            return hasInvalidCustomerBaseData() || hasInvalidShippingAddress();
        }

        function transactionToWhatsAppMessage() {
            var orderNumber = vm.transactionId;
            var payment = vm.invoice.paymentCondition === 'MONEY' ? 'Dinheiro/Pix' : 'Cartão';
            var today = new moment().format("DD/MM/YYYY");
            var todayHour = new moment().format("HH:mm:ss");
            var totalPurchase = vm.currencyPrefix + $filter('number')(vm.purchaseValue, 2);
            var products = '';

            for (var i = 0; i < vm.invoice.items.length; i++) {
                var item = vm.invoice.items[i];
                var purchasePrice = $filter('number')(vm.getItemPrice(item), 2);
                var totalPurchasePrice = $filter('number')(vm.getItemSubtotal(item), 2);

                var color = ''
                if (item.detail.size && item.detail.color) {
                    color = " " + item.detail.color.name;
                }
                var size = '';
                if (item.detail && item.detail.size && item.detail.size !== 'DEFAULT') {
                    size = " " + item.detail.size;
                }
                var productReference = item.flyer.productReference ? ' - ' + item.flyer.productReference : '';

                products += "▪ " + item.flyer.name + productReference + color + size + "\n   " + item.quantity + " x " + purchasePrice.replace(/\./g, 'D').replace(/,/g, '.').replace(/D/g, ',') + " = *" + totalPurchasePrice.replace(/\./g, 'D').replace(/,/g, '.').replace(/D/g, ',') + "*\n \n";
            }

            var complement = '';
            if (vm.invoice.complement) {
                complement = vm.invoice.complement + ', ';
            }
            var shippingAdress = vm.invoice.customer.address + ', ' + vm.invoice.customer.addressNumber + ', ' + complement + vm.invoice.customer.district + ', ' + vm.invoice.customer.city + ', ' + vm.invoice.customer.state + ', ' + vm.invoice.customer.zipcode;
            var frete = '';

            if (vm.invoice.shippingOption === 'PICK_UP_IN_STORE') {
                shippingAdress = 'Retirar na Loja';
            } else if (vm.invoice.shippingValue && vm.invoice.shippingValue > 0) {
                frete = "*Frete:* " + vm.currencyPrefix + " " + vm.invoice.shippingValue + "\n"
            } else if (vm.selectedCoupon && vm.selectedCoupon.discountType === "FREE_SHIPPING") {
                frete = "*Frete:* Grátis \n"
            } else {
                frete = "*Frete:* A combinar \n"
            }

            var subtotal = vm.currencyPrefix + $filter('number')(vm.invoice.subTotal, 2);
            var discount = vm.currencyPrefix + $filter('number')(vm.invoice.discount || 0, 2);
            var whatsAppMessage = '\
🔔 *NOVO PEDIDO - ' + orderNumber + '* \n' + ' \
*Loja:* ' + vm.store.name + '\n \
*Vendedor:* ' + vm.invoice.sellerName + '\n \
........................................................ \n \
👤 *Cliente:* ' + vm.invoice.customer.fullName + ' \n \
📞 *WhatsApp:* ' + (vm.invoice.customer.phone || '-') + ' \n \
........................................................ \n \
🏷 *Produtos* \n\n \
\
' + products + '\n \
\
' + frete + ' \
\
*Subtotal*: ' + subtotal.replace(/D/g, ',') + ' \n \
\
*Desconto*: ' + discount.replace(/D/g, ',') + ' \n \
\
*Total*: ' + totalPurchase.replace(/D/g, ',') + ' \n \
........................................................ \n \
🛵 *Entrega:* ' + shippingAdress + ' \n \
........................................................ \n \
💳 *Forma de pagamento:* ' + payment + ' \n \
 ....................................................... \n \
💬 *Observações:* ' + (vm.invoice.notes || '') + ' \n \
........................................................ \n\n \
\
📆 *' + today + '* às 🕟 *' + todayHour + '*';

            return whatsAppMessage;

        }

        function transactionImmoToWhatsAppMessage() {
            var orderNumber = vm.transactionId;
            var today = new moment().format("DD/MM/YYYY");
            var todayHour = new moment().format("HH:mm:ss");
            var totalPurchase = vm.currencyPrefix + $filter('number')(vm.purchaseValue, 2);
            var immo = '';

            for (var i = 0; i < vm.invoice.items.length; i++) {
                var item = vm.invoice.items[i];
                var totalPurchasePrice = $filter('number')(vm.getItemSubtotal(item), 2);

                var unit = '';
                if (item.detail && item.detail.unit) {
                    unit = " " + item.detail.unit;
                }
                var address = '';

                if (item.flyer && item.flyer.address) {
                    address = item.flyer.address;
                }
                var productReference = item.flyer.productReference ? ' - ' + item.flyer.productReference : '';

                immo += "▪ " + item.flyer.name + productReference + " \n " + " Unidade " + unit + " = * R$ " + totalPurchasePrice.replace(/\./g, 'D').replace(/,/g, '.').replace(/D/g, ',') + "*\n " +
                    " Localização: " + address.street + " \n " +
                    " Cidade: " + address.city +  " \n " +
                    " Estado: " + address.state + " \n " +
                    " Cep: " + address.cep + "\n \n";

            }

            var discount = vm.currencyPrefix + $filter('number')(vm.invoice.discount || 0, 2);
            var subtotal = vm.currencyPrefix + $filter('number')(vm.invoice.subTotal, 2);

            var whatsAppMessage = '\
🔔 *NOVA RESERVA - ' + orderNumber + '* \n' + ' \
*Loja:* ' + vm.store.name + '\n \
*Corretor:* ' + vm.invoice.sellerName + '\n \
........................................................ \n \
👤 *Cliente:* ' + vm.invoice.customer.fullName + ' \n \
📞 *WhatsApp:* ' + (vm.invoice.customer.phone || '-') + ' \n \
........................................................ \n \
🏷 *Imóvel(s)* \n\n \
\
' + immo + '\n \
\
\
*Subtotal*: ' + subtotal.replace(/D/g, ',') + ' \n \
\
*Desconto*: ' + discount.replace(/D/g, ',') + ' \n \
\
*Total*: ' + totalPurchase.replace(/D/g, ',') + ' \n \
........................................................ \n \
💬 *Observações:* ' + (vm.invoice.notes || '') + ' \n \
........................................................ \n\n \
\
📆 *' + today + '* às 🕟 *' + todayHour + '*';

            return whatsAppMessage;

        }


    }

})();
